import { v4 as uuidv4 } from 'uuid'

export const activities = [...new Array(5)].map((_: any, index: number) => ({
  id: uuidv4(),
  code: 'ATY' + ++index,
  name: 'Activity ' + index,
  __typename: 'Activity'
}))
